import { render } from "./FooterInternas.vue?vue&type=template&id=28dde0ba&scoped=true"
import script from "./FooterInternas.vue?vue&type=script&lang=js"
export * from "./FooterInternas.vue?vue&type=script&lang=js"

import "./FooterInternas.vue?vue&type=style&index=0&id=28dde0ba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28dde0ba"]])

export default __exports__